<template>
  <div>
  <GatewayList moneyType="1722" />
  </div>
</template>
<script>
import GatewayList from "./GatewayList";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "dollersGatewayList",
  components: {
    GatewayList
  },
  mounted(){
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "درگاه های دلاری" }]);
  }
};
</script>
<style>
.hidden {
  display: none;
}
</style>
